import { Container, Row, Col } from "react-bootstrap";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Experience = () => {
    const experiences = [
        {
            role: "Tech. Lead — R&D Engineer",
            company: "HCLTech",
            duration: "Sept. 2025 – Present",
            location: "Bangalore, India",
            points: [
                "Drive modernization and feature enhancement of HPE’s enterprise telecom platform acquired by HCLTech, delivering production-grade features and critical fixes for large-scale systems serving users across 10+ countries.",
                "Independently implemented 3GP container support for the EVS codec, including compliant EVS sample-entry box implementation and automated test coverage for reliable EVS media validation.",
                "Architected and delivered an end-to-end SRTP-DTLS encrypted calling pipeline, including DTLS fingerprint validation and 10 cryptographic key-exchange configurations across SDES and DTLS-SRTP, compliant with RFC 3711, RFC 5763 and RFC 5764.",
                "Designed and shipped a GUI-based dynamic SRTP configuration framework, reducing QA environment setup and testing time by 60%; owned 80+ Jira stories across requirements analysis, development, integration and release.",
                "Performed packet-level SIP/RTP/SRTP/DTLS traffic analysis and debugging using Wireshark and developed automated NRT test suites for DTLS-SRTP and SDES-SRTP."
            ]
        },
        {
            role: "Fullstack Software Developer Intern",
            company: "Nullclass",
            duration: "Jan. 2024 – Jun. 2024",
            location: "Remote — Bangalore, India",
            points: [
                "Engineered and deployed a scalable full-stack web application using React.js, Node.js, Express and MongoDB, integrating 10+ REST APIs with caching and lazy-loading strategies that reduced response latency by 60%.",
                "Optimized backend performance by redesigning MongoDB schemas with compound indexes across 100K+ records and implementing JWT-based authentication, reducing query execution time by 50% and improving data throughput by 70%."
            ]
        }
    ];

    return (
        <section className="experience" id="experience">
            <Container>
                <Row>
                    <Col>
                        <TrackVisibility>
                            {({ isVisible }) => (
                                <div
                                    className={
                                        isVisible
                                            ? "animate__animated animate__slideInUp"
                                            : ""
                                    }
                                >
                                    <h2>Professional Experience</h2>

                                    <p className="experience-intro">
                                        Building production-grade software systems across
                                        enterprise telecom, full-stack development, networking,
                                        security and backend engineering.
                                    </p>
                                </div>
                            )}
                        </TrackVisibility>

                        <div className="experience-timeline">
                            {experiences.map((experience, index) => (
                                <div className="experience-item" key={index}>
                                    <div className="experience-marker">
                                        <span></span>
                                    </div>

                                    <div className="experience-card">
                                        <div className="experience-header">
                                            <div>
                                                <h3>{experience.role}</h3>
                                                <h4>{experience.company}</h4>
                                            </div>

                                            <div className="experience-meta">
                                                <span>{experience.duration}</span>
                                                <span>{experience.location}</span>
                                            </div>
                                        </div>

                                        <ul>
                                            {experience.points.map((point, pointIndex) => (
                                                <li key={pointIndex}>{point}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};